import { render, staticRenderFns } from "./gdpr-consent.vue?vue&type=template&id=a6a132fa&lang=pug&"
import script from "./gdpr-consent.vue?vue&type=script&lang=js&"
export * from "./gdpr-consent.vue?vue&type=script&lang=js&"
import style0 from "./gdpr-consent.vue?vue&type=style&index=0&id=a6a132fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports